export const UPDATE_ACTIVE_PROGRAM_SECTION = "UPDATE_ACTIVE_PROGRAM_SECTION";
export const FETCHING_ACTIVE_PROGRAM_SECTION =
  "FETCHING_ACTIVE_PROGRAM_SECTION";
export const CANCEL_FETCH_ACTIVE_PROGRAM_SECTION =
  "CANCEL_FETCH_ACTIVE_PROGRAM_SECTION";
